import { pluralizeWord } from '@shared/helpers/formatters';

import type { CellProps } from './types';

export const TicketsCell = ({ row }: CellProps) => {
  return (
    <span className="text-base-text-pink text-caption-sm-a">
      {String(row.ticketsAmount)} {pluralizeWord('Ticket', Number(row.ticketsAmount))}
    </span>
  );
};
